import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { GlobalState } from "../../../../GlobalState";
import { TabTitle } from "../../../../util/titleChanger";
import { toast } from "react-toastify";
import "./invoiceview.css";

function InvoiceView() {
  TabTitle("Invoice View");
  const { invId } = useParams();
  const state = useContext(GlobalState);

  const [invoiceDetail] = state.invoiceAPI.invoiceDetail;
  const [invoiceId, setInvoiceId] = state.invoiceAPI.invoiceId;
  const [productsList] = state.productAPI.productsList;

  const [values, setValues] = useState("");
  const [productValues, setProductValues] = useState([]);

  useEffect(() => {
    setProductValues([]);
    if (invId > 0) {
      setInvoiceId(invId);
      var today = new Date();
      var created_at = invoiceDetail.data ? invoiceDetail.data.created_at : undefined;

      setValues({
        invoice_no: invoiceDetail.data?.invoice_no || "",
        total_amount: invoiceDetail.data?.total_price || "00.00",
        total_discount: invoiceDetail.data?.total_discount || "00.00",
        net_total: invoiceDetail.data?.net_price || "00.00",
        customer_name: invoiceDetail.data?.customer?.first_name + " " + invoiceDetail.data?.customer?.last_name || "",
        created_at: created_at === undefined ? today.toISOString().substring(0, 10) : new Date(created_at).toISOString().substring(0, 10),
      });

      if (invoiceDetail.data && invoiceDetail.data !== "Can't find invoice!") {
        invoiceDetail.data.bills.forEach((billProduct) => {
          const productItem = productsList.data.find((product) => product.id === billProduct.product.id);
          if (productItem) {
            setProductValues((prev) => [
              ...prev,
              {
                id: productItem.id,
                product_name: productItem.name,
                quantity: billProduct.quantity,
                unit_price: billProduct.unit_price,
                total_price: billProduct.total_price,
                total_discount: billProduct.total_discount,
              },
            ]);
          }
        });
      }
    }
  }, [invoiceId, productsList, invoiceDetail]);

  // ✅ Same receipt styles
  const getReceiptStyles = () => `
    @page {
      size: 80mm auto;
      margin: 0;
    }
    body {
      width: 80mm !important;
      font-family: 'Courier New', monospace;
      font-size: 12px;
      padding: 5mm;
      background: white;
      color: black;
    }
    .receipt {
      width: 100%;
    }
    .header, .footer {
      text-align: center;
      font-weight: bold;
      margin: 10px 0;
    }
    .divider {
      border-top: 1px dashed #000;
      margin: 5px 0;
    }
    .item-row {
      display: flex;
      justify-content: space-between;
      margin: 3px 0;
    }
    .total {
      font-weight: bold;
    }
  `;

  // ✅ Unified HTML builder
  const generateReceiptHTML = (invoice) => `
    <div class="receipt">
      <div class="header">
        <h3>BUY ME NOW</h3>
        <p>Invoice #${invoice.invoice_no}</p>
        <p>Date: ${new Date(invoice.created_at).toLocaleString()}</p>
        <p>Customer: ${invoice.customer?.first_name || ""} ${invoice.customer?.last_name || ""}</p>
      </div>
      <div class="divider"></div>
      ${invoice.bills
        ?.map(
          (item) => `
          <div class="item-row">
            <span>${item.quantity}x ${item.product.name}</span>
            <span>Rs ${parseFloat(item.total_price).toFixed(2)}</span>
          </div>`
        )
        .join("")}
      <div class="divider"></div>
      <div class="item-row total">
        <span>Total:</span>
        <span>Rs ${parseFloat(invoice.net_price).toFixed(2)}</span>
      </div>
      <div class="footer">Thank you for shopping!</div>
    </div>
  `;

  // ✅ Print handler
  const handlePrint = () => {
    if (!invoiceDetail.data) return toast.error("No invoice data to print!");
    const invoice = invoiceDetail.data;

    const content = `
      <html>
        <head>
          <title>Invoice #${invoice.invoice_no}</title>
          <style>${getReceiptStyles()}</style>
        </head>
        <body>
          ${generateReceiptHTML(invoice)}
          <script>
            setTimeout(() => window.print(), 100);
          </script>
        </body>
      </html>
    `;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(content);
    printWindow.document.close();
    toast.success("Print window opened");
  };

  return (
    <div className="main-container-purchase">
      <h1>{values.invoice_no}</h1>
      <h3>{values.created_at}</h3>
      <div>
        <div className="left-main-container">
          <div className="quantity">
            Customer : <span>{values.customer_name}</span>
          </div>
          <div className="supplier">
            Total Amount : <span>Rs .{values.total_amount}</span>
          </div>
          <div className="total">
            Total Discount : <span>Rs. {values.total_discount}</span>
          </div>
          <div className="description">
            Net Total : <span>Rs. {values.net_total}</span>
          </div>
        </div>
        <div className="right-main-container">
          <table>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Unit price</th>
                <th>Qty</th>
                <th>Total Discount</th>
                <th>Net Total</th>
              </tr>
            </thead>
            <tbody>
              {productValues.map((product) => (
                <tr key={product.id}>
                  <td>{product.product_name}</td>
                  <td>Rs. {product.unit_price}</td>
                  <td>{product.quantity}</td>
                  <td>Rs. {product.total_discount}</td>
                  <td>Rs. {product.total_price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ✅ Print button */}
      <div style={{ marginTop: "20px" }}>
        <button className="print-button" onClick={handlePrint}>
          <i className="uil uil-print"></i> Print Invoice
        </button>
      </div>
    </div>
  );
}

export default InvoiceView;
